import { Component, Input } from '@angular/core';
import { Report } from '../../../models/report.model';

@Component({
  selector: 'app-details-dossier-read-mode',
  templateUrl: './details-dossier-read-mode.component.html',
  styleUrls: ['./details-dossier-read-mode.component.scss'],
})
export class DetailsDossierReadModeComponent {
  @Input() detailsDossier!: Report.Case;
}
